<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import FileApi from '@/api/common/file';
import MapAPI from '@/api/topologymap/common';
import msgUtil from '@/utils/message';

import WTroubleTicket from '@/views/event/trouble-ticket';

export default {
  name: 'WTopologymapTroubleTicket',
  extends: WTroubleTicket,
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
    active: {
      handler(value) {
        if (value === false) {
          this.clear();
        }
      },
    },
  },
  methods: {
    loadData() {
      if (isNil(this.active) || !this.active) {
        return;
      }
      const tableParams = this.$refs.troubleTicketTable.getParameter();
      const pagination = this.$refs.troubleTicketTable.getPagination();
      const params = {
        ...tableParams,
        pageSize: pagination.pageSize,
        searchType: this.searchType,
        searchDateField: this.searchDateField,
        searchValue: this.searchValue,
        startDatetime: this.dateRange[0].getTime(),
        endDatetime: this.dateRange[1].getTime(),
        mapId: this.$store.getters.getCurrentMapId,
      };
      this.loading = true;

      MapAPI.getTroubleShootingList(params)
        .then((response) => {
          if (response.data.success) {
            if (isEmpty(response.data.data) && response.data.total !== 0) {
              this.loadPage(response.data.lastPage);
            } else {
              this.troubleTicketTableParams = params;
              this.troubleShootingData = response.data.data;
              this.totalCount = response.data.total;
              const groupIdInfo = [];
              this.troubleShootingData.forEach((item) => {
                groupIdInfo.push({
                  troubleTicketGroupId: item.troubleTicketGroupId,
                  nextId: item.nextTicketId,
                  prevId: item.prevTicketId,
                });
              });
              this.ticketIdsList = groupIdInfo;
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장애 티켓', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장애 티켓', false));
          throw new Error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    exportExcel() {
      const params = {
        searchType: this.searchType,
        searchValue: this.searchValue,
        startDatetime: this.dateRange[0].getTime(),
        endDatetime: this.dateRange[1].getTime(),
        mapId: this.$store.getters.getCurrentMapId,
      };

      MapAPI.getTroubleShootingExcelName(params)
        .then((response) => {
          if (response.data.success && !isEmpty(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getCustomResultMsgData('엑셀로 출력하지 못하였습니다.', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getCustomResultMsgData('엑셀로 출력하지 못하였습니다.', false));
          throw new Error(e);
        });
    },
    clear() {
      this.loading = false;
      this.totalCount = 0;
      this.searchType = 'subject';
      this.searchValue = null;
      this.troubleShootingData = null;
      this.ticketIdsList = [];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/event/TopologymapTroubleTicket.vue